import { KeywordQuery } from "../keyword-query";

export default class BrandProductQuery extends KeywordQuery {
	constructor() {
		super();
		this.queryData["keyword"] = null;
		this.queryData.isbrandproductsearch = true;
	}
}
